import {
  Type,
} from '@angular/core';
import {
  EntryCustomComponents,
  registerCustomComponent,
} from '@o3r/components';
import {
  CustomBackToMmbPresComponent,
  CustomBackToMmbPresModule,
  CustomRefundTeaserContComponent,
  CustomRefundTeaserContModule,
} from './components/index';
/**
 * Helper function to register the custom components
 *
 * @example
 * {
 * const firstCompMap = registerCustomComponent(new Map(), 'firstCompKey', FirstComponent);
 * const secondCompMap = registerCustomComponent(firstCompMap, 'secondCompKey', SecondComponent);
 * return secondCompMap;
 * }
 */
export function registerCustomComponents(): Map<string, any> {
  const customComponents: Map<string, Type<any>> = new Map();
  registerCustomComponent(customComponents, 'CustomBackToMmbPresComponent', CustomBackToMmbPresComponent);
  registerCustomComponent(customComponents, 'CustomRefundTeaserContComponent', CustomRefundTeaserContComponent);
  return customComponents;
}

/** Returns the array of custom components and the array of associated components modules */
export function initializeEntryComponents(): EntryCustomComponents {
  return {
    customComponents: [CustomBackToMmbPresComponent, CustomRefundTeaserContComponent],
    customComponentsModules: [CustomBackToMmbPresModule, CustomRefundTeaserContModule]
  };
}
